import { Button, Col, Form, Input, message, Modal, Row, Select, Space, Typography } from "antd";
import * as yup from "yup";
import React, { useState } from "react";
import { api, get } from "~/Services";
import { ErrorMessage, Field, FieldProps, Formik } from "formik";
import TextArea from "antd/lib/input/TextArea";
import { useNotification } from "~/Hooks/useNotification";

const initialValue = {
  message: "",
  documentId: "",
};

interface Props {
  id: any;
  showResendModal: boolean;
  onCancel: () => void;
  onSuccess: () => void;
}

export const ResendModal = ({ id, showResendModal, onCancel, onSuccess }: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { openNotification } = useNotification();
  const validationSchema = yup.object().shape({
    message: yup.string().required("Comment is required"),
  });

  return (
    <Formik
      onSubmit={(values, formikHelpers) => {
        setIsLoading(true);
        const formdata = JSON.stringify({
          envelopeId: id,
          comment: values.message,
        });
        api
          .post("v1/spa/resend-document", formdata, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            formikHelpers.resetForm();
            setIsLoading(true);
            onSuccess();
            openNotification({
              title: "Success",
              message: "Request Successfully send",
              type: "success",
            });
            setIsLoading(false)
            
          })
          .catch((err) => {
            setIsLoading(false)
            openNotification({
              title: "Error",
              message: "Request Failed",
              type: "error",
            });
            onCancel();
          });
      }}
      initialValues={initialValue}
      validationSchema={validationSchema}
    >
      {({ submitForm, resetForm, setFieldValue, touched, errors, isValid, dirty, values }) => {
        return (
          <Modal
            title={"Resend"}
            maskClosable={false}
            open={showResendModal}
            
            onOk={() => {
              
              submitForm();
            }}
            okButtonProps={{ disabled: !(isValid && dirty) }}
            onCancel={() => {
              onCancel();
              resetForm();
            }}
            okText={"Resend with comment"}
          confirmLoading={isLoading}
            width={600}
            centered
          >
            <Form
              layout="vertical"
              onFinish={submitForm}
            >
              <Field name={"message"}>
                {({ field, meta }: FieldProps) => {
                  return (
                    <Form.Item
                      label={"Reason for Resend"}
                      validateStatus={meta.touched && meta.error ? "error" : ""}
                    >
                      <TextArea
                        rows={4}
                        maxLength={5000}
                        showCount
                        {...field}
                      />
                      {meta.touched && meta.error && (
                        <Typography.Text type="danger">{meta.error.toString()}</Typography.Text>
                      )}
                    </Form.Item>
                  );
                }}
              </Field>
            </Form>
          </Modal>
        );
      }}
    </Formik>
  );
};
